/* eslint-disable import/dynamic-import-chunkname */
/**
 * The webpackChunkName "translations.foo" is important. Do not change without updating following files:
 * - packages/confluence-frontend-server/webpack.config.js
 * - packages/confluence-frontend-server/templates/generator.js
 */
function fetchLanguage(locale) {
	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (!process.env.REACT_SSR) {
		/**
		 * en-ZZ is a special locale used for locate translation strings. Real user won't see it.
		 * Split the condition statements so webpack can remove the whole thing when compiling for SSR
		 * SSR doesn't have splits this file will make the ssr-app significantly bigger
		 */
		if (locale === 'en-ZZ') {
			return () =>
				import(
					/* webpackChunkName: "translations.en-ZZ" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/en-ZZ'
				);
		}
	}

	const languageHash = {
		'fr-FR': () =>
			import(
				/* webpackChunkName: "translations.fr-FR" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/fr-FR'
			),

		'de-DE': () =>
			import(
				/* webpackChunkName: "translations.de-DE" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/de-DE'
			),

		'ja-JP': () =>
			import(
				/* webpackChunkName: "translations.ja-JP" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/ja-JP'
			),

		'es-ES': () =>
			import(
				/* webpackChunkName: "translations.es-ES" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/es-ES'
			),

		'ko-KR': () =>
			import(
				/* webpackChunkName: "translations.ko-KR" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/ko-KR'
			),

		'pt-BR': () =>
			import(
				/* webpackChunkName: "translations.pt-BR" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/pt-BR'
			),

		'ru-RU': () =>
			import(
				/* webpackChunkName: "translations.ru-RU" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/ru-RU'
			),

		'en-GB': () =>
			import(
				/* webpackChunkName: "translations.en-GB" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/en-GB'
			),

		'da-DK': () =>
			import(
				/* webpackChunkName: "translations.da-DK" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/da-DK'
			),

		'et-EE': () =>
			import(
				/* webpackChunkName: "translations.et-EE" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/et-EE'
			),

		'fi-FI': () =>
			import(
				/* webpackChunkName: "translations.fi-FI" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/fi-FI'
			),

		'hu-HU': () =>
			import(
				/* webpackChunkName: "translations.hu-HU" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/hu-HU'
			),

		'is-IS': () =>
			import(
				/* webpackChunkName: "translations.is-IS" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/is-IS'
			),

		'it-IT': () =>
			import(
				/* webpackChunkName: "translations.it-IT" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/it-IT'
			),

		'nl-NL': () =>
			import(
				/* webpackChunkName: "translations.nl-NL" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/nl-NL'
			),

		'no-NO': () =>
			import(
				/* webpackChunkName: "translations.no-NO" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/no-NO'
			),

		'pl-PL': () =>
			import(
				/* webpackChunkName: "translations.pl-PL" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/pl-PL'
			),

		'ro-RO': () =>
			import(
				/* webpackChunkName: "translations.ro-RO" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/ro-RO'
			),

		'sk-SK': () =>
			import(
				/* webpackChunkName: "translations.sk-SK" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/sk-SK'
			),

		'cs-CZ': () =>
			import(
				/* webpackChunkName: "translations.cs-CZ" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/cs-CZ'
			),

		'sv-SE': () =>
			import(
				/* webpackChunkName: "translations.sv-SE" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/sv-SE'
			),

		'zh-CN': () =>
			import(
				/* webpackChunkName: "translations.zh-CN" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/zh-CN'
			),

		'zh-TW': () =>
			import(
				/* webpackChunkName: "translations.zh-TW" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/zh-TW'
			),
	};

	return locale in languageHash ? languageHash[locale] : undefined;
}

export function lazyLanguage(locale) {
	const promises = [
		import(
			/* webpackChunkName: "translations.en-US" */ '@atlassian/afm-i18n-confluence-confluence-frontend-server/i18n/en-US'
		),
	];
	const languageChunk = fetchLanguage(locale);
	if (languageChunk) {
		promises.push(languageChunk());
	}
	return promises;
}
